import { Component, Input, Output, EventEmitter, ElementRef, HostListener, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-single-select-dropdown',
    templateUrl: './single-select-dropdown.component.html',
    styleUrls: ['./single-select-dropdown.component.scss']
})
export class SingleSelectDropdownComponent implements OnChanges {
    @Input() options: { id: number | string, name: string }[] = [];
    @Input() selectedId: number | string | null = null;
    @Input() placeholder: string = 'Select...';
    @Input() disabled: boolean = false;
    @Output() selectionChange = new EventEmitter<{ id: number | string, name: string } | null>();

    searchTerm: string = '';
    isOpen: boolean = false;
    selectedOption: { id: number | string, name: string } | null = null;

    constructor(private eRef: ElementRef) { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['selectedId'] || changes['options']) {
            if (this.options?.length && this.selectedId) {
                this.selectedOption = this.options.find(opt => opt.id === this.selectedId) || null;
            } else {
                this.selectedOption = null;
            }
        }
    }

    toggleDropdown() {
        if (this.disabled) {
            return;
        }
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.searchTerm = '';
        }
    }

    @HostListener('document:click', ['$event'])
    handleOutsideClick(event: Event) {
        if (this.isOpen && !this.eRef.nativeElement.contains(event.target)) {
            this.isOpen = false;
        }
    }

    selectOption(option: any) {
        if (this.disabled) {
            return;
        }
        this.selectedOption = option;
        this.searchTerm = '';
        this.isOpen = false;
        this.selectionChange.emit(option);
    }

    clearSelection(event: Event) {
        if (this.disabled) {
            return;
        }
        event.stopPropagation();
        this.selectedOption = null;
        this.searchTerm = '';
        this.selectionChange.emit(null);
    }

    get filteredOptions() {
        return this.options.filter(opt =>
            opt.name.toLowerCase().includes(this.searchTerm.toLowerCase())
        );
    }

    get displayText(): string {
        return this.selectedOption?.name || this.placeholder;
    }
}
